import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { ACTION, SUBJECT } from "../../../../constants/permissions";
import { paymentInformation } from "../../../../config/router/routes";
import { IPaymentMethodInfoProps } from "./types";
import { useAbility } from "../../../../hooks";
import Icon from "../../../../components/Icon";
import { IconName } from "../../../../components/Icon/types";

export const PaymentMethodInfo: FC<IPaymentMethodInfoProps> = ({
  paymentMethod,
  paymentMethodIconName,
}) => {
  const { t } = useTranslation();
  const ability = useAbility();

  return (
    <>
      {!ability.can(ACTION.WRITE, SUBJECT.BILLING) ? (
        <>{paymentMethod ? t(paymentMethod) : null}</>
      ) : (
        <Link
          className="ams-active-subscription__payment-method flex flex-align-center"
          to={paymentInformation.path}
        >
          <Icon className="ams-payment-icon">
            {paymentMethodIconName as IconName}
          </Icon>
          {paymentMethod ? t(paymentMethod) : t("addPaymentMethod")}
        </Link>
      )}
    </>
  );
};
